import { render, staticRenderFns } from "./formLinks.vue?vue&type=template&id=53395318&scoped=true"
import script from "./formLinks.vue?vue&type=script&lang=js"
export * from "./formLinks.vue?vue&type=script&lang=js"
import style0 from "./formLinks.vue?vue&type=style&index=0&id=53395318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53395318",
  null
  
)

export default component.exports